<div #dxfviewer class="dxf-viewer" [ngStyle]="{ height: customHeight }">
  <div class="contain-progress">
    <div style="text-align: center" id="progress-viewer"></div>
    <div id="progress-viewer-bar">
      <div id="progress-bar"></div>
    </div>
  </div>
</div>
